import { useState } from 'react'

import Header from 'apps/employer_renewals/components/Header'
import PageContainer from 'apps/employer_renewals/components/layout/PageContainer'
import NavigationButtons from 'apps/employer_renewals/components/NavigationButtons'
import useAppNavigation from 'apps/employer_renewals/hooks/useAppNavigation'
import useGenerateRenewalQuotes from 'apps/employer_renewals/hooks/useGenerateRenewalQuotes'
import useRenewalEmployees from 'apps/employer_renewals/hooks/useRenewalEmployees'
import { EmployerRenewalsRoute } from 'apps/employer_renewals/routes'
import { Banner } from 'components/reusable/Banner'

import RenewalEmployeesTable from './RenewalEmployeesTable'

export default function EligibilityPage () {
  const { eligibleEmployeeIds, isLoading, employeeIdsInvitedInCurrentYearWithMissingRequiredInfo } = useRenewalEmployees({})
  const { generateRenewalQuotes, isLoading: isGeneratingQuotes, isError: isErrorGeneratingQuotes } = useGenerateRenewalQuotes()
  const [shakeMissingInfoBanner, setShakeMissingInfoBanner] = useState(false)

  const { navigateTo } = useAppNavigation()

  const onConfirm = async () => {
    const results = await generateRenewalQuotes()
    if (results) {
      navigateTo(EmployerRenewalsRoute.ALLOWANCES_REVIEW)
    }
  }

  return (
    <PageContainer maxWidth='lg'>
      <Header
        heading="Confirm who's eligible for healthcare benefits in 2026"
        subheading='Any employees marked as "Eligible" will be automatically invited to enroll in plans on Nov 5.'
      />
      <RenewalEmployeesTable shakeMissingInfoBanner={shakeMissingInfoBanner} />
      {isErrorGeneratingQuotes && (
        <Banner type='critical' titleText='Something went wrong'>
          Something went wrong. Please try again. If the problem persists, please contact support.
        </Banner>
      )}
      <NavigationButtons
        nextButtonText={eligibleEmployeeIds.size === 0 ? 'No eligible employees' : `Confirm ${eligibleEmployeeIds.size} eligible employees`}
        isNextDisabled={isLoading || eligibleEmployeeIds.size === 0 || employeeIdsInvitedInCurrentYearWithMissingRequiredInfo.length > 0}
        isLoading={isGeneratingQuotes}
        onNext={onConfirm}
        nextButtonTooltipText={employeeIdsInvitedInCurrentYearWithMissingRequiredInfo.length > 0 ? `${employeeIdsInvitedInCurrentYearWithMissingRequiredInfo.length} employee${employeeIdsInvitedInCurrentYearWithMissingRequiredInfo.length > 1 ? 's are' : ' is'} missing required information. Please update their information before continuing.` : undefined}
        onNextButtonMouseLeave={() => setShakeMissingInfoBanner(false)}
        onNextButtonMouseEnter={() => {
          if (employeeIdsInvitedInCurrentYearWithMissingRequiredInfo.length > 0) {
            setShakeMissingInfoBanner(true)
          }
        }}
      />
    </PageContainer>
  )
}
